import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70deb732")

_pushScopeId("data-v-70deb732")
const _hoisted_1 = { class: "page post-entry-page" }
const _hoisted_2 = {
  href: "/",
  class: "segment back-home"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "arrow-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "arrow-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "arrow-left" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_post = _resolveComponent("post")!

  return (_openBlock(), _createBlock("article", _hoisted_1, [
    _createVNode("div", {
      class: ["post-header", { 'has-category': _ctx.pageData.post.category }]
    }, [
      _createVNode("a", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_font_awesome_icon, { icon: "home" })
      ]),
      (_ctx.pageData.post.category)
        ? (_openBlock(), _createBlock("a", {
            key: 0,
            href: _ctx.pageData.post.category.url,
            class: "segment category"
          }, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(_component_font_awesome_icon, { icon: "folder" }),
            _hoisted_7,
            _createVNode("span", null, _toDisplayString(_ctx.pageData.post.category.title), 1)
          ], 8, ["href"]))
        : _createCommentVNode("", true),
      (_ctx.pageData.post.category)
        ? (_openBlock(), _createBlock("a", {
            key: 1,
            href: _ctx.pageData.post.url,
            class: "segment title"
          }, [
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_font_awesome_icon, { icon: "file-alt" }),
            _hoisted_10,
            _createVNode("span", null, _toDisplayString(_ctx.pageData.post.title), 1)
          ], 8, ["href"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_post)
  ]))
})